/**
 * 导入模块
 */
import { showErrorOverlay } from './modules/overlay';

/**
 * 导出初始化方法
 */
const init = (rootEleId?: string): void => {
  /**
   * 全局的错误监控事件
   */
  window.addEventListener('error', (e: ErrorEvent): void => {
    if (e.message && e.message.includes('Unexpected token')) {
      showErrorOverlay();
    }

    if (e.target) {
      const tagName = (e.target as Element).tagName;
      if (tagName == 'SCRIPT') {
        showErrorOverlay();
      }
    }
  });

  /**
   * 全局的加载监听事件
   */
  window.addEventListener('load', (): void => {
    const elementId = rootEleId || 'app';
    const rootEle: HTMLElement | null = document.getElementById(elementId);
    if (!rootEle) {
      console.warn('当前项目未找到入口的根节点，请确定元素根节点是否正确');
      return;
    }
    setTimeout(() => {
      if (!rootEle.innerHTML) {
        showErrorOverlay();
      }
    }, 1000);
  });
};

export { init };
